"use strict";

// This is a simplified/polyfilled version of reselect compatible with older browsers.
// This is likeley to be removed once we have a custom webpack config for Retailer.
// See https://github.com/reduxjs/reselect/releases/tag/v4.1.6

Object.defineProperty(exports, "__esModule", {
    value: true,
});

exports.createSelector = createSelector;
exports.createSelectorCreator = createSelectorCreator;
exports.defaultMemoize = defaultMemoize;
exports.defaultEqualityCheck = defaultEqualityCheck;

function defaultEqualityCheck(a, b) {
    return a === b;
}

function defaultMemoize(func, equalityCheck) {
    equalityCheck = equalityCheck || defaultEqualityCheck;

    var lastArgs = null;
    var lastResult = null;

    return function () {
        var args = arguments;

        if (lastArgs === null) {
            lastResult = func.apply(null, args);
            lastArgs = args;
            return lastResult;
        }

        var changed = false;
        if (args.length !== lastArgs.length) {
            changed = true;
        } else {
            for (var i = 0; i < args.length; i++) {
                if (!equalityCheck(args[i], lastArgs[i])) {
                    changed = true;
                    break;
                }
            }
        }

        if (changed) {
            lastResult = func.apply(null, args);
            lastArgs = args;
        }

        return lastResult;
    };
}

function createSelectorCreator(memoize) {
    var memoizeFunc = memoize || defaultMemoize;

    return function () {
        var args = Array.prototype.slice.call(arguments);
        var selectors = args.slice(0, args.length - 1);
        var combiner = args[args.length - 1];

        var recomputations = 0;

        var resultFunc = function () {
            recomputations++;
            var params = [];
            var length = selectors.length;

            for (var i = 0; i < length; i++) {
                params.push(selectors[i].apply(null, arguments));
            }

            return combiner.apply(null, params);
        };

        var selector = memoizeFunc(resultFunc);
        selector.resultFunc = resultFunc;
        selector.recomputations = function () {
            return recomputations;
        };
        selector.resetRecomputations = function () {
            recomputations = 0;
        };

        return selector;
    };
}

var createSelector = createSelectorCreator(defaultMemoize);
